import axios from '../request/http';
import {toFormData} from '../common/descriptions'

const setup = {
    // 路由列表
    menuBar(params){
        return axios.get("/admin/roles/routesInfo", { params });
    },
    // 新增修改路由
    routeList(data){
        return axios.post("/admin/roles/routeAddOrEdit", data );
    },
    // 删除路由
    routeDl(params){
        return axios.get("/admin/roles/routeDel", { params });
    },
    // 更改路由状态
    routeDel(params){
        return axios.get("/admin/roles/routeStatus", {params} );
    },
    // 获取角色列表
    role(params){
        return axios.get("/admin/roles/list", { params });
    },
    // 新增或修改角色
    modifyrole(params){
        return axios.get("/admin/roles/rolesGroupEditOrAdd", { params }  );
    },
    // 后台用户列表
    adminList(params){
        return axios.get("/admin/admin-info/list", { params } );
    },
    // 后台用户删除
    adminEnable(params){
        return axios.get("/admin/admin-info/enable", { params } );
    },
    // 新增编辑后台用户
    adminEdit(data){
        return axios.post("/admin/admin-info/edit", data  );
    },
    // 分销记录列表
    shareRecordList(params){
        return axios.get("/admin/share/record/list", { params } );
    },
    // 分销列表
    shareSetList(params){
        return axios.get("/admin/share/set/list", { params } );
    },
//    分销配置
shareSetEdit(params){
    return axios.get("/admin/share/set/edit", { params } );
},

  
        
}

export default setup;


// WEBPACK FOOTER //
// ./src/api/setup.js